module.exports = __webpack_public_path__ + "12a3d67a6b2425e01fbd266c6bed25bb.pdf";